import React from "react";
import './topeventgallery.css';

function TopEventGallery() {
    return (
        <section id="gallery-42">
            <div className="cs-container">
                <div className="cs-content">
                    <div className="cs-flex">
                        <span className="cs-topper">Milwaukee Sai Center</span>
                        <h2 className="cs-title">Education, Service and Spirituality</h2>
                    </div>
                    <div className="cs-flex">
                        <p className="cs-text">
                            Sri Sathya Sai Center - Milwaukee has been privileged to host a variety of events that celebrate community, culture, and spirituality. Our gallery showcases moments from these gatherings, reflecting the joy and unity experienced by all attendees.
                        </p>
                        {/* <a aria-label="view more pictures" href="" className="cs-link">
                            View More
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.01 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13H16.01V14.79C16.01 15.24 16.55 15.46 16.86 15.14L19.64 12.35C19.83 12.15 19.83 11.84 19.64 11.64L16.86 8.84999C16.55 8.52999 16.01 8.75999 16.01 9.19999V11Z" fill="#14142B"/>
                            </svg>
                        </a> */}
                    </div>
                </div>
                <div className="cs-image-group">
                    <picture className="cs-picture cs-picture-1">
                        <source media="(max-width: 600px)" srcSet="/images/topgallery/topgallery-1.jpeg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/topgallery/topgallery-1.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/topgallery/topgallery-1.jpeg" alt="Sai Center milwaukee Service" width="380" height="271"></img>
                    </picture>
                    <picture className="cs-picture cs-picture-2">
                        <source media="(max-width: 600px)" srcSet="/images/topgallery/topgallery-2.jpeg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/topgallery/topgallery-2.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/topgallery/topgallery-2.jpeg" alt="Sai Center milwaukee Service" width="380" height="271"></img>
                    </picture>
                    <picture className="cs-picture cs-picture-3">
                        <source media="(max-width: 600px)" srcSet="/images/topgallery/topgallery-3.jpeg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/topgallery/topgallery-3.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/topgallery/topgallery-3.jpeg" alt="Sai Center milwaukee SSE" width="780" height="582"></img>
                    </picture>
                    <picture className="cs-picture cs-picture-4">
                        <source media="(max-width: 600px)" srcSet="/images/topgallery/topgallery-4.jpeg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/topgallery/topgallery-4.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/topgallery/topgallery-4.jpeg" alt="Sai Center Milwaukee SSE" width="780" height="582"></img>
                    </picture>
                    <picture className="cs-picture cs-picture-5">
                        <source media="(max-width: 600px)" srcSet="/images/topgallery/topgallery-5.jpeg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/topgallery/topgallery-5.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/topgallery/topgallery-5.jpeg" alt="Service Sai Activity" width="380" height="271"></img>
                    </picture>
                    <picture className="cs-picture cs-picture-6">
                        <source media="(max-width: 600px)" srcSet="/images/topgallery/topgallery-6.jpeg"></source>
                        <source media="(min-width: 601px)" srcSet="/images/topgallery/topgallery-6.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/topgallery/topgallery-6.jpeg" alt="SSE Class" width="380" height="271"></img>
                    </picture>
                </div>
            </div>
        </section>
    );
}

export default TopEventGallery;